import { render, staticRenderFns } from "./funds.vue?vue&type=template&id=595e7771&scoped=true&"
import script from "./funds.vue?vue&type=script&lang=js&"
export * from "./funds.vue?vue&type=script&lang=js&"
import style0 from "./funds.vue?vue&type=style&index=0&id=595e7771&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595e7771",
  null
  
)

export default component.exports